import React from "react";
import DefaultMenu from "../../menu/layouts/default";
// import CPMenu from "../../menu/layouts/cp";
import { MENU_LAYOUTS } from "../../textConstans";

const Header2Nav = (props) => {
  const {
    logged,
    // cp,
    navSections,
    segmentMenu,
    // municipios,
    // municipio,
    // showCP,
    forceSelect,
  } = props;
  const selector = logged ? "logged" : "default";
  return (
    <div className="container">
      <nav className="header2-nav" aria-label = "Menú principal">
        <div className="menu">
          <ul className="section-menu" data-cy="Header links">
            {navSections && navSections[selector] && (
              <DefaultMenu
                items={navSections[selector]}
                layout={MENU_LAYOUTS.DEFAULT}
                forceSelect={forceSelect}
                location="main"
              />
            )}
          </ul>
          <ul className="segment-menu" data-cy="Header secondary links">
            {segmentMenu && segmentMenu[selector] && (
              <DefaultMenu
                items={segmentMenu[selector]}
                layout={MENU_LAYOUTS.DEFAULT}
                forceSelect={forceSelect}
                location="main"
              />
            )}
          </ul>
        </div>
        {/* {showCP && (
          <ul className="options">
            <CPMenu
              layout={MENU_LAYOUTS.CP}
              location="menu"
              cp={cp}
              municipios={municipios}
              municipio={municipio}
            />
          </ul>
        )} */}
      </nav>
      <style jsx>{`@import "styles/colors.scss";

.header2-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;

  :global(.menu) {
    display: none;
    white-space: nowrap;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    overflow: hidden;
    &::-webkit-scrollbar {
      display: none;
    }

    :global(.menu-item.selected) {
      :global(.text) {
        color: $color--grey_700 !important;
        text-decoration: solid underline currentColor 2px;
        text-underline-offset: 4px;
        text-decoration-skip-ink: none;
      }
    }
    :global(.menu-item) {
      :global(.text:hover) {
        color: $color--grey_700 !important;
        text-decoration: solid underline currentColor 1px;
        text-underline-offset: 4px;
        text-decoration-skip-ink: none;
      }

      :global(.text:active) {
        color: $color--grey_700 !important;
        text-decoration: solid underline currentColor 1px;
        text-underline-offset: 4px;
        text-decoration-skip-ink: none;
      }
    }
  }
  .options {
    display: flex;
    align-items: center;

    :global(button:focus) {
      outline: none;
    }

    :global(.menu-item) {
      display: flex;
      align-items: center;
      gap: 0.25rem;

      :global(.text-gap) {
        :global(.text) {
          &:hover {
            color: $color--grey_700 !important;

            @media (max-width: 768px) {
              color: $color--movistar_blue !important;
            }
          }
        }
      }

      :global(.close) {
        padding-left: 0.5rem;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .header2-nav {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    :global(.menu) {
      display: flex;
      gap: 1rem;

      :global(.section-menu) {
        display: none;
        gap: 1rem;

        :global(.menu-item) {
          display: inline;
        }
      }

      :global(.segment-menu) {
        display: none;
        gap: 1rem;
      }
    }

    .options {
      justify-content: flex-end;
      gap: 0.5rem;

      :global(.menu-item) {
        :global(.text-gap) {
          :global(.text) {
            color: $color--grey_600 !important;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .header2-nav {
    :global(.menu) {
      :global(.section-menu) {
        display: flex;

        :global(.menu-item) {
          display: inline;
        }
      }
    }
  }
}
@media screen and (min-width: 1280px) {
  .header2-nav {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    gap: 0.5rem;

    :global(.text) {
      text-wrap: nowrap;
    }

    :global(.menu) {
      max-height: 40px;   
      gap: 1.5rem;   

      :global(.section-menu) {
        gap: 1.5rem;

        :global(.menu-item) {
          display: inline;
        }
      }

      :global(.segment-menu) {
        display: flex;
        flex-flow: row wrap;
        row-gap: 1rem;
        gap: 1.5rem;

        :global(.next-link) {
          display: flex;

          &:last-child {
            display: none;
          }

          &:first-child {
            display: flex;
          }

          &::before {
            display: inline-block;
            padding-right: 0.5rem;
            padding-left: 0.5rem;
            color: $color--movistar_black;
            content: "|";
            font-size: 0.875rem;
            padding-top: 0.15rem;
          }
        }
      }
    }
  }
}
`}</style>
    </div>
  );
};
export default Header2Nav;
